import { useEffect, useState } from "react";
import type { Route } from "../router";
import { useLang } from "../context/LangContext";
import { getFaqList } from "../content/faq";
import { renderMarkdown } from "../services/markdown";

export function FaqPage({ route }: { route: Route }) {
  const { lang, t } = useLang();
  const faq = getFaqList(lang);

  // #/faq/<id> opens that item (e.g. from a search result).
  const deepLinked = route.segments.length > 1 ? route.segments[1] : null;
  const [open, setOpen] = useState<string | null>(deepLinked);

  useEffect(() => {
    if (deepLinked) {
      setOpen(deepLinked);
      const el = document.getElementById(`faq-${deepLinked}`);
      el?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [deepLinked]);

  return (
    <div className="page faq">
      <div className="page-head">
        <h1>{t.faqTitle}</h1>
        <p className="muted">
          {t.faqSubtitleBefore}
          <a href="#/docs">{t.faqSubtitleLink}</a>
          {t.faqSubtitleAfter}
        </p>
      </div>

      <div className="faq-list">
        {faq.map((item) => {
          const isOpen = open === item.id;
          return (
            <div
              key={item.id}
              id={`faq-${item.id}`}
              className={`faq-item${isOpen ? " open" : ""}`}
            >
              <button
                className="faq-q"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? null : item.id)}
              >
                <span>{item.question}</span>
                <span className="faq-caret" aria-hidden="true">
                  {isOpen ? "−" : "+"}
                </span>
              </button>
              {isOpen && (
                <div
                  className="faq-a doc-body"
                  dangerouslySetInnerHTML={{ __html: renderMarkdown(item.answer) }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
